import React from 'react';
import UnitTypesTable, {getUnitFriendIconSrc} from '../../UnitTypesTable/UnitTypesTable';
import UNIT_TYPES from '../../../configs/units';

const UnitsRules = () => {
  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const size = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/unit size.png'}
    alt={'Размер'}
    title={'Размер отряда'}
  />;
  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const coinsIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;
  const coinsPlusOneIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты за размер'}
    title={'Монеты за размер'}
  />;
  const speedIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/speed.png'}
    alt={'Дальность перемещения'}
    title={'Дальность перемещения'}
  />;
  const unitSizeIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/unit size.png'}
    alt={'Размер'}
    title={'Размер отряда'}
  />;
  const shootingIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/shooting.png'}
    alt={'Дальность стрельбы'}
    title={'Дальность стрельбы'}
  />;



  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-war">
        Отряды
      </h2>

      <div className="rules-page_section">
        <p>
          Отряды размещаются на поле через покупку на казармах {barracks}.
          <br/>Одну ячейку на поле всегда может занимать только 1 отряд.
        </p>
        <p>
          <b>Размер отряда</b> {size} — характеристика, которая определяет его прочность и силу. Она накапливается
          постепенно, и при покупке отряда всегда равна 1. Чем выше размер отряда, тем больше урона {damage} он
          наносит и больше прочности имеет. У каждого типа отряда есть предельный лимит размера.
        </p>
        <ul>
          <li>Когда отряд снабжается {supply}, его размер увеличивается из раунда в раунд — его
            кость переворачивается гранью с большим числом вверх.
            <br/>
            <span className={'text-war'}>!</span> Рост размера отряда за {supply} в <span className={'text-supply'}>фазе Снабжения</span> не
            требует траты монет {coinsIcon}.
          </li>
          <li>Когда отряд получает урон {damage}, его размер уменьшается — его кость переворачивается
            гранью с меньшим числом вверх.
          </li>
        </ul>
      </div>

      <div className="rules-page_section">
        <h2>Типы отрядов</h2>
        <p>
          В игре есть 6 типов отрядов (не считая уникальные отряды некоторых фракций):
        </p>
        {Object.values(UNIT_TYPES).map((unitType) => (
          <div
            key={unitType.id}
            className={'policy-description_line policy-description_line-margin-top'}
          >
            <img
              className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
              src={getUnitFriendIconSrc(unitType.id)}
              alt={unitType.description}
              title={unitType.description}
            />
            {unitType.description}
          </div>
        ))}
        <p>
          У каждого типа отряда есть следующие характеристики:
        </p>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          • {unitSizeIcon} Максимальный размер отряда
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          • {coinsIcon} Цена найма отряда
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          • {coinsPlusOneIcon} Цена увеличения размера отряда на +1
        </div>
        <div className={'policy-description_line policy-description_line-margin-top'}>
          (мгновенный найм с кварталов в <span
          className={'policy-description-icon-margin-left text-war'}
        >фазе Войны</span>)
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          • {speedIcon} Дальность перемещения отряда
        </div>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-big'}>
          • {shootingIcon} Дальность стрельбы
        </div>

        <UnitTypesTable/>
      </div>
    </div>
  );
};

export default UnitsRules;
